import { render } from "./StuffCanvas.vue?vue&type=template&id=2a92eda2"
import script from "./StuffCanvas.vue?vue&type=script&lang=js"
export * from "./StuffCanvas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__